import {
    ANT_standard,
    APS_standard,
    CPS_standard,
    EPS_standard,
    EXT_standard,
    MRSN_standard,
    MTS_standard
} from "@/js/models/experimental-design";


function getScreenMetadata(screen_name) {
    return {
        type: getScreenType(screen_name),
        number: getScreenNumber(screen_name), // screen_name.match(/\d+/)[0],
        name: screen_name
    }
}

function getScreenType(screen) {
    if (screen.includes("MTS")) {
        return "MTS";
    } else if (screen.includes("CPS")) {
        return "CPS";
    } else if (screen.includes("EPS") || screen.includes("ULA")) {
        return "EPS";
    } else if (screen.startsWith("MRSN")) {
        return "MRSN";
    } else if (screen.startsWith("EXT")) {
        return "EXT";
    } else if (screen.startsWith("APS")) {
        return "APS";
    } else if (screen.startsWith("ANT")) {
        return "ANT";
    } else if (screen.startsWith("PSEL")) {
        return "PSEL";
    } else {
        console.warn("Screen type not found", screen)
        return "unknown"
    }
}

function getScreenNumber(screen) {
    return screen.match(/\d+/)[0];
}

export function getVersionMetadata(screen_name, section_id) {
    const screenMetadata = getScreenMetadata(screen_name)
    const sectionVersion = getSectionVersion(screenMetadata, section_id)
    return Object.assign({}, screenMetadata, sectionVersion, {section: section_id})
}


//TO DO: Which screens/numbers have different overview text?
function getOverviewVersion(screen) {
    switch (screen.type) {
        case "APS":
            if (screen.number >= 2) {
                return {version: 'aps2'}
            } else {
                return {version: 'aps1'}
            }
        case "ANT":
            return {version: '1'}
        case "CPS":
            return {version: '1'}
        case "EPS": 
            if (screen.number === "004") {
                return {version: 'eps4'}
            } 
            if (screen.number === "009") {
                return {version: '9'}
            } 
            else if (screen.number === "011") {
                return {version: '11'}
            } 
            else if (screen.number === "014") {
                return {version: '14'}
            } 
            else {
                return {version: "ext1"} // change to number?
            }
        case "EXT":
            return {version: "ext1"}
        case "MTS":
            return {version: '1'}
        case "MRSN":
            return {version: '1'}
        default:
            return {version: '1'}
    }
}

//TO DO: Which screens/numbers have different versions for DRC?
function getDRCVersion(screen) {
    switch (screen.type) {
        case "APS":
            if (screen.number >= 2) {
                return {version: '2'}
            } else {
                return {version: '1'}
            }
        case "ANT":
            return {version: '1'}
        case "CPS":
            if (screen.number >= 9) {
                return {version: '2'}
            } else {
                return {version: '1'}
            }
        case "EPS":
            return {version: 'ext1'}
        case "EXT":
            return {version: 'ext1'}
        case "MTS":
            if (screen.number >= 24) {
                return {version: '2'}
            } else {
                return {version: '1'}
            }
        case "MRSN":
            return {version: '1'}
        default:
            return {version: '1'}
    }
}

function getBlissMssVersion(screen) {
    switch (screen.type) {
        case "CPS":
            return {version: '1'}
        default:
            return {version: '1'}
    }
}

function getSynergyVersion(screen) {
    switch (screen.type) {
        case "CPS":
            return {version: '1'}
        default:
            return {version: '1'}
    }
}

function getViabilityVersion(screen) {
    switch (screen.type) {
        case "APS":
            return {version: '1'}
        case "ANT":
            return {version: '1'}
        case "CPS":
            return {version: '1'}
        case "EPS":
            return {version: 'ext1'}
        case "EXT":
            return {version: 'ext1'}
        case "MTS":
            return {version: '1'}
        case "MRSN":
            return {version: '1'}
        default:
            return {version: '1'}
    }
}

function getLineageEnrichmentVersion(screen) {
    switch (screen.type) {
        case "APS":
            return {version: '1'}
        case "ANT":
            return {version: '1'}
        case "CPS":
            return {version: '1'}
        case "EPS":
            return {version: 'ext1'}
        case "EXT":
            return {version: 'ext1'}
        case "MTS":
            return {version: '1'}
        case "MRSN":
            return {version: '1'}
        default:
            return {version: '1'}
    }
}

function getMutationEffectVersion(screen) {
    switch (screen.type) {
        case "APS":
            return {version: '1'}
        case "ANT":
            return {version: '1'}
        case "CPS":
            return {version: '1'}
        case "EPS":
            return {version: 'ext1'}
        case "EXT":
            return {version: 'ext1'}
        case "MTS":
            return {version: '1'}
        case "MRSN":
            return {version: '1'}
        default:
            return {version: '1'}
    }
}

function getCorrelationAnalysisVersion(screen) {
    switch (screen.type) {
        case "APS":
            return {version: '1'}
        case "ANT":
            return {version: '1'}
        case "CPS":
            return {version: '1'}
        case "EPS":
            return {version: 'ext1'}
        case "EXT":
            return {version: 'ext1'}
        case "MTS":
            return {version: '1'}
        case "MRSN":
            return {version: '1'}
        default:
            return {version: '1'}
    }
}

function getMultivariateBiomarkerAnalysisVersion(screen) {
    switch (screen.type) {
        case "APS":
            return {version: '1'}
        case "ANT":
            return {version: '1'}
        case "CPS":
            return {version: '1'}
        case "EPS":
            return {version: 'ext1'}
        case "EXT":
            return {version: 'ext1'}
        case "MTS":
            return {version: '1'}
        case "MRSN":
            return {version: '1'}
        default:
            return {version: '1'}
    }
}

function getSensitivityComparisonVersion(screen) {
    switch (screen.type) {
        case "APS":
            return {version: '1'}
        case "ANT":
            return {version: '1'}
        case "CPS":
            return {version: '1'}
        case "EPS":
            return {version: 'ext1'}
        case "EXT":
            return {version: 'ext1'}
        case "MTS":
            return {version: '1'}
        case "MRSN":
            return {version: '1'}
        default:
            return {version: '1'}
    }
}

function getContinuousAssociationsVersion(screen) {
    switch (screen.type) {
        case "APS":
            return {version: '1'}
        case "ANT":
            return {version: '1'}
        case "CPS":
            return {version: '1'}
        case "EPS":
            return {version: 'ext1'}
        case "EXT":
            return {version: 'ext1'}
        case "MTS":
            return {version: '1'}
        case "MRSN":
            return {version: '1'}
        default:
            return {version: '1'}

    }
}

function getRandomForestModelsVersion(screen) {
    switch (screen.type) {
        case "APS":
            return {version: '1'}
        case "ANT":
            return {version: '1'}
        case "CPS":
            return {version: '1'}
        case "EPS":
            return {version: "ext1"}
        case "EXT":
            return {version: "ext1"}
        case "MTS":
            return {version: '1'}
        case "MRSN":
            return {version: '1'}
        default:
            return {version: '1'}
    }
}

function getBiomarkerVersion(screen) {
    switch (screen.type) {
        case "APS":
            return {version: '1'}
        case "ANT":
            return {version: '1'}
        case "CPS":
            return {version: '1'}
        case "EPS":
            return {version: "ext1"}
        case "EXT":
            return {version: "ext1"}
        case "MTS":
            return {version: '1'}
        case "MRSN":
            return {version: '1'}
        default:
            return {version: '1'}
    }
}

// TO DO: should get rid of this and just check which version each download-data-type is
function getDataDownloadsVersion(screen) {
    switch (screen.type) {
        case "APS":
            if (screen.number >= 2) {
                return {version: '2'}
            } else {
                return {version: '1'}
            }
        case "ANT":
            return {version: '1'}
        case "CPS":
            if (screen.number >= 9) {
                return {version: '2'}
            } else {
                return {version: '1'}
            }
        case "EPS":
            return {version: "ext1"}
        case "EXT":
            return {version: "ext1"}
        case "MTS":
            if (screen.number >= 24) {
                return {version: '2'}
            } else {
                return {version: '1'}
            }
        case "MRSN":
            return {version: '1'}
        default:
            return {version: '1'}

    }
}

function getQualityControlVersion(screen) {
    switch (screen.type) {
        case "APS":
            if (screen.number >= 3) {
                return {version: '3'}
            } else {
                return {version: '1'} //most recent is default
            }
        case "MRSN":
            return {version: '1'}
        case "ANT":
            return {version: '1'}
        case "CPS":
            if (screen.number >= 11) {
                return {version: '3'}
            } else {
                return {version: '1'} //most recent is default
            }
        case "EPS":
            return {version: "ext1"}
        case "EXT":
            return {version: "ext1"}
        case "MTS":
            if (screen.number >= 25) {
                return {version: '3'}
            } else {
                return {version: '1'} //most recent is default
            }
        default:
            return {version: '1'}
    }
}

// NOT SURE what the relationship between this version, and all other section versions is?
// ie: data processing = version 2, but qc = version 1?
function getDataProcessingVersion(screen) {
    switch (screen.type) {
        case "APS":
            if (screen.number >= 4) {
                return {version: '4'}
            } else if (screen.number >= 3) {
                return {version: '3'}
            } else if (screen.number >= 2) {
                return {version: '2'}
            } else {
                return {version: '1'}
            }
        case "ANT":
            return {version: '1'}
        case "CPS":
            if (screen.number >= 11) {
                return {version: '4'}
            } else if (screen.number >= 10) {
                return {version: '3'}
            } else if (screen.number >= 9) {
                return {version: '2'}
            } else {
                return {version: '1'}
            }
        case "EPS":
            return {version: "ext1"}
        case "EXT":
            return {version: "ext1"}
        case "MTS":
            if (screen.number >= 26) {
                return {version: '4'}
            } else if (screen.number >= 25) {
                return {version: '3'}
            } else if (screen.number >= 24) {
                return {version: '2'}
            } else {
                return {version: '1'}
            }
        case "MRSN":
            return {version: '1'}
        default:
            return {version: '1'}
    }
}


export function getDepMapVersionString(screen) {
    switch (screen.type) {
        case "APS":
            if (screen.number >= 2) {
                return '(DepMap 23Q4)'
            } else {
                return '(DepMap 23Q2)'
            }
        case "CPS":
            if (screen.number >= 10) {
                return '(DepMap 23Q4)'
            } else {
                return '(DepMap 23Q2)'
            }
        case "EPS":
            return '(DepMap 23Q4)'
        case "EXT":
            return '(DepMap 23Q4)'
        case "MTS":
            if (screen.number >= 24) {
                return '(DepMap 23Q4)'
            } else {
                return '(DepMap 23Q2)'
            }
        default:
            return ''
    }
}


export function getSectionVersion(screen, section_id, args) {
    switch (section_id) {
        case "qc":
            return getQualityControlVersion(screen);
        case "downloads":
            return getDataDownloadsVersion(screen);
        case "data-processing":
            return getDataProcessingVersion(screen);
        case "overview":
            return getOverviewVersion(screen);
        case "depmap_version":
            return {}
        case "dose-response":
            return getDRCVersion(screen);
        case "viability-heatmap":
            return getViabilityVersion(screen);
        case "lineage-enrichment":
            return getLineageEnrichmentVersion(screen);
        case "mutation-effect":
            return getMutationEffectVersion(screen);
        case "correlation-analysis":
            return getCorrelationAnalysisVersion(screen);
        case "multivariate-biomarker-analysis":
            return getMultivariateBiomarkerAnalysisVersion(screen);
        case "sensitivity-comparison":
            return getSensitivityComparisonVersion(screen);
        case "continuous-associations":
            return getContinuousAssociationsVersion(screen);
        case "random-forest-models":
            return getRandomForestModelsVersion(screen);
        case "synergy-by-dose":
            return getSynergyVersion(screen)
        case "bliss-mss":
            return getBlissMssVersion(screen)
        case "biomarker":
            return getBiomarkerVersion(screen)
        default:
            return {}
    }
}

// gets called from over view pages
export function getExperimentalDesign(screen, args) {
    switch (screen.type) {
        case "MTS":
            MTS_standard[screen.version].experimental_design = `This compound was screened in the PRISM assay at 
            ${MTS_standard[screen.version].NUM_DOSES}-point dose 
            (${MTS_standard[screen.version].DILUTION}-fold dilution) with a 
            ${MTS_standard[screen.version].NUM_DAYS}-day treatment with
            ${args.num_cl_pass} cancer cell lines passing QC.`
            return MTS_standard[screen.version]
        case "CPS":
            if (args.nDoses === 8) { // For when MTS compounds are run on CPS plates
                MTS_standard[screen.version].experimental_design = `This compound was screened in the PRISM assay at 
                ${MTS_standard[screen.version].NUM_DOSES}-point dose 
                (${MTS_standard[screen.version].DILUTION}-fold dilution) with a 
                ${MTS_standard[screen.version].NUM_DAYS}-day treatment with
                ${args.num_cl_pass} cancer cell lines passing QC.`
                return MTS_standard[screen.version]
            } else if (args.nDoses === 25 || args.nDoses === 5) {  // For 5x5 combinations
                CPS_standard[screen.version].experimental_design = `For each combination tested, both compounds were screened in the PRISM assay at dose 
                (5-point dose with 3-fold dilutions) alone and at all 25 corresponding dose pairs in combination
                with a 5-day treatment with ${args.num_cl_pass} cancer cell lines passing QC.`
                return CPS_standard[screen.version]
            } else {
                CPS_standard[screen.version].experimental_design = `These compounds were screened in the PRISM assay as the treatment compound at dose
                (${CPS_standard[screen.version].NUM_DOSES}-point dose with ${CPS_standard[screen.version].DILUTION}-fold dilutions) alone, 
                the anchor compound at one anchor dose alone, 
                and the treatment compound at dose  (${CPS_standard[screen.version].NUM_DOSES}-point dose with ${CPS_standard[screen.version].DILUTION}-fold dilutions) 
                plus the anchor compound at one anchor dose with a 
                ${CPS_standard[screen.version].NUM_DAYS}-day treatment with
                ${args.num_cl_pass} cancer cell lines passing QC.`
                return CPS_standard[screen.version]
            }
        case "EPS":
            EPS_standard[screen.version].experimental_design = `This compound was screened in the PRISM assay at 
            ${EPS_standard[screen.version].NUM_DOSES}-point dose with a
            ${EPS_standard[screen.version].NUM_DAYS}-day treatment with 
            ${args.num_cl_pass} cancer cell lines passing QC.`
            return EPS_standard[screen.version]
        case "EXT":
            EXT_standard[screen.version].experimental_design = `This compound was screened in the PRISM assay at 
            ${EXT_standard[screen.version].NUM_DOSES}-point dose with a
            ${EXT_standard[screen.version].NUM_DAYS}-day treatment with 
            ${args.num_cl_pass} cancer cell lines passing QC.`
            return EXT_standard[screen.version]
        case "MRSN":
            MRSN_standard[screen.version].experimental_design = `This test agent was screened in the PRISM assay at 
            ${MRSN_standard[screen.version].NUM_DOSES}-point dose 
            (${MRSN_standard[screen.version].DILUTION}-fold dilution) with a 
            ${MRSN_standard[screen.version].NUM_DAYS}-day treatment with 
            ${args.num_cl_pass} cancer cell lines passing QC.`
            return MRSN_standard[screen.version]
        case "APS":
            APS_standard[screen.version].experimental_design = `This test agent was screened in the PRISM assay at 
            ${APS_standard[screen.version].NUM_DOSES}-point dose 
            (${APS_standard[screen.version].DILUTION}-fold dilution) with a 
            ${APS_standard[screen.version].NUM_DAYS}-day treatment with 
            ${args.num_cl_pass} cancer cell lines passing QC.`
            return APS_standard[screen.version]
        case "ANT":
            ANT_standard[screen.version].experimental_design = `This compound was screened in the PRISM assay at 
            ${ANT_standard[screen.version].NUM_DOSES}-point dose 
            (${ANT_standard[screen.version].DILUTION}-fold dilution) with a 
            ${ANT_standard[screen.version].NUM_DAYS}-day treatment with 
            ${args.num_cl_pass} cancer cell lines passing QC.`
            return ANT_standard[screen.version]
        default:
            console.warn(`No experimental design found for this screen type: ${screen.name}. Defaulting to MTS_standard`)
            return "No experimental design found"
    }

}


// export function getProjectDownloadsDataDetails(version, data_type,depmap_version){
//     version = version.toString()
//     switch (version) {
//         case "1":
//             switch (data_type){
//                     case "compound_data":
//                         return "<h3>Dose response curve data</h3>" +
//                             "<p>For each cell line passing QC, we attempt to fit a 4-parameter log logistic dose-response " +
//                             "curve and for each curve we compute summary statistics including AUC and IC50 " +
//                             "(for cell lines killed to below 50% viability). Cell lines with noisy data (often due to " +
//                             "insensitivity to the tested drug), curves may not be able to be fit and are thus omitted " +
//                             "from this table.</p>" +
//                             "<p>This file contains, for each drug and cell line screened, the following: dose range, " +
//                             "dose-response parameters (upper limit, lower limit, slope, and EC50), summary statistics (AUC, IC50), " +
//                             "and information about accuracy of fitted curve (convergence, MSE, R2).</p>" +
//                             "<h3>Quality Control metrics</h3>" +
//                             "<p>Table containing all quality control metrics including: vehicle control data, positive control data, " +
//                             "SSMD, error rate, and the dynamic range and error rate statistics, which are used to determine whether " +
//                             "a cell line is included in downstream analyses." +
//                             "</p>" +
//                             "<h3>Raw and Normalized fluorescence values</h3>" +
//                             "<p>Mean fluorescent intensities (MFI) for each control and treatment well. " +
//                             "This is a measure of the abundance of each PRISM barcode for each replicate/treatment/cell line, " +
//                             "available in long-table format</p>" +
//                             "<h3>Replicate-collapsed viability data</h3>" +
//                             "<p>Replicate collapsed viability data for median-collapsed values across cell lines, available in " +
//                             "long-table format.</p>" +
//                             "<h3>Viability data</h3>" +
//                             "<p>Normalized (log fold-change) cell-viability values " +
//                             "with respect to vehicle control, available in long-table format.</p>"

//                         case "biomarker_data":
//                             return "<h3>Biomarker and correlation analysis </h3>" +
//                                 "<p>Biomarker and correlation analysis using omics and genetic dependency data from " +
//                                 "<a href='https://depmap.org/portal/download/all/' target='depMap'>depmap.org</a>. " +
//                                 "<span> " + depmap_version + "</span></p>" +
//                                 "<p>Biomarkers are identified by selecting the genomic features that best explain the " +
//                                 "observed profile of sensitivity in the PRISM cell line panel.</p>" +
//                                 "<h3>Random forest features</h3>" +
//                                 "<p>Multivariate analysis with random forest for two models: CCLE (includes lineage, " +
//                                 "gene expression, mutation, and copy number features) and Complete " +
//                                 "(includes all 4 CCLE features plus CRISPR knock-out, RPPA, micro RNA, and metabolomics).</p>" +
//                                 "<h3>Discrete associations</h3>" +
//                                 "<p>Univariate analysis for discrete variables including: lineage enrichment and mutation effect.</p>" +
//                                 "<h3>Continuous associations</h3>" +
//                                 "<p>Univariate analysis for continuous variables including: gene expression, copy number, metabolomics, " +
//                                 "repurposing compounds, CRISPR knock-out, proteomics, micro RNA, and shRNA knockdown.</p>" +
//                                 "<h3>Random forest model statistics</h3><p>Multivariate analysis with model level statistics.</p>"

//                         case "combination_data":
//                             return "<h3>Bliss MSS</h3> <p></p> <h3>Synergy</h3> <p></p>";
//             }
//         break;
//         case "2":
//             switch (data_type){
//                 case "compound_data":
//                     return "<h3>Dose response curve data</h3><p>For each cell line passing QC, we attempt to fit a 4-parameter log logistic dose-response curve and for each curve we compute summary statistics including AUC and IC50. An IC50 is reported only if the fitted curve crosses 50% viability within the dose range of the experiment. If curve fit does not succeed, the fit parameters are omitted, and only the Riemann AUC is provided.</p><p>This file contains, for each drug and cell line screened, the following: dose range, dose-response parameters (upper limit, lower limit, slope, and EC50), summary statistics (AUC, IC50), Riemann AUC, constraints used in fitting (single-agent or combination), and information about accuracy of fitted curve (convergence, MSE, R2).</p><h3>Quality Control metrics</h3><p>Table containing all quality control metrics including: vehicle control data, positive control data, SSMD, error rate, and the dynamic range and error rate statistics, which are used to determine whether a cell line is included in downstream analyses.</p><h3>Raw and Normalized fluorescence values</h3><p>Mean fluorescent intensities (MFI) for each control and treatment well. This is a measure of the abundance of each PRISM barcode for each replicate/treatment/cell line, available in long-table format.</p><h3>Replicate-collapsed viability data</h3><p>Replicate collapsed viability data for median-collapsed values across cell lines, available in long-table format.</p><h3>Viability data</h3><p>Normalized (log fold-change) cell-viability values with respect to vehicle control, available in long-table format.</p>"
//                 case "biomarker_data":
//                     return "<h3>Biomarker and correlation analysis </h3>" +
//                         "<p>Biomarker and correlation analysis using omics and genetic dependency data from " +
//                         "<a href='https://depmap.org/portal/download/all/' target='depMap'>depmap.org</a>. " +
//                         "<span>" + depmap_version + "</span>" +
//                         "</p>" +
//                         "<p>Biomarkers are identified by selecting the genomic features that best explain " +
//                         "the observed profile of sensitivity in the PRISM cell line panel.</p>" +
//                         "<h3>Random forest features</h3>" +
//                         "<p>Multivariate analysis with random forest for two models: CCLE (includes lineage, " +
//                         "gene expression, mutation, and copy number features) and Complete (includes all " +
//                         "4 CCLE features plus CRISPR knock-out, RPPA, micro RNA, and metabolomics).</p>" +
//                         "<h3>Discrete associations</h3>" +
//                         "<p>Univariate analysis for discrete variables including: lineage enrichment and " +
//                         "mutation effect.</p><h3>Continuous associations</h3>" +
//                         "<p>Univariate analysis for continuous variables including: gene expression, copy number, " +
//                         "metabolomics, repurposing compounds, CRISPR knock-out, proteomics, micro RNA, and " +
//                         "shRNA knockdown." +
//                         "</p>" +
//                         "<h3>Random forest model statistics</h3>" +
//                         "<p>Multivariate analysis with model level statistics.</p>"
//                 case "combination_data":
//                     return "<h3>Bliss MSS</h3> <p></p> <h3>Synergy</h3> <p></p>"
//             }
//             break;
//         default:
//             return "No data downloads details found for this screen type"
//     }
// }


export function getIncludedDoseMetrics(meta) {

    let string;
    if (meta.version == 'ext1') {
        string = `(including log<sub>2</sub>AUC)`
    } else {
        string = `(including log<sub>2</sub>AUC and log<sub>2</sub>IC50)`
    }
    return string
}
